import axios from "axios";
import { useState } from "react";
import Swal from "sweetalert2";

const PHONE_NUMBER = "010-5629-0176";

export default function BottomBar() {
  const [name, setName] = useState<string>("");
  const [phone, setPhone] = useState<string>("");

  // const [loading, setLoading] = useState(false);

  const handlerPostContact = async () => {
    if (!name || !phone) {
      Swal.fire({
        title: "이름, 연락처를 모두 입력해주세요.",
        icon: "error",
      });
      return false;
    }

    if (phone.length !== 11 || !phone.includes("010")) {
      alert("010을 포함한 연락처를 모두 입력해주세요.");
      return false;
    }

    if (!window.confirm("문의 접수를 위한 개인정보 수집에 동의하시나요?")) {
      return false;
    }

    // setLoading(true);

    await axios
      .post("/api/contact/quick", {
        name: name,
        phone: phone,
        path: sessionStorage.getItem("path"),
      })
      .then((res) => {
        if (res.data.result === "0000") {
          Swal.fire({
            title: "문의 완료!",
            text: "문의 등록이 완료되었습니다.",
            icon: "success",
          }).then(() => (window.location.href = "/transform"));
        }
      })
      .catch((e) => {
        // setLoading(false);
        Swal.fire({
          title: e,
          icon: "error",
        }).then(() => (window.location.href = "/"));
      });
  };

  return (
    <div className="fixed inset-x-0 bottom-0 lg:bottom-3 z-10">
      {/* Desktop bar: phone banner + inline form */}
      <div className="hidden items-center gap-6 bg-gradient-to-b from-[#ffbc64] to-[#e46e26] px-6 py-3 md:flex md:px-10 max-w-screen-lg mx-auto rounded-2xl">
        <img
          src={"/images/quickPc.png"}
          alt="무료견적 365일 24시간 긴급출동 010.5629.0176"
          className="h-9 w-auto shrink-0 lg:h-10"
        />

        <form className="flex flex-1 items-center gap-3" onSubmit={(e) => e.preventDefault()}>
          <input
            type="text"
            value={name}
            id="name3"
            onChange={(e) => setName(e.target.value)}
            placeholder="이름 입력"
            className="w-full max-w-[180px] rounded-sm bg-white px-4 py-2.5 text-center text-sm text-gray-700 placeholder:text-primary focus:outline-none focus:ring-2 focus:ring-white/60"
          />
          <input
            type="tel"
            value={phone}
            id="phone3"
            maxLength={11}
            onChange={(e) => setPhone(e.target.value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1"))}
            placeholder="전화번호 (010-0000-0000)"
            className="w-full max-w-[260px] rounded-sm bg-white px-4 py-2.5 text-center text-sm text-gray-700 placeholder:text-primary focus:outline-none focus:ring-2 focus:ring-white/60"
          />

          <div className="flex shrink-0 flex-col items-center gap-1 pl-2">
            <button
              type="button"
              onClick={handlerPostContact}
              className="whitespace-nowrap rounded-full bg-white px-6 pt-0.5 text-sm font-bold text-primary transition-colors hover:bg-gray-100"
            >
              문의 접수하기
            </button>
            <label className="flex items-center gap-1 text-[11px] text-white/90">
              <input type="checkbox" defaultChecked checked className="h-3 w-3 rounded-full -mt-0.5" />
              개인정보처리방침 동의
            </label>
          </div>
        </form>
      </div>

      {/* Mobile bar: full-image banner, tap to call */}
      <a href={`tel:${PHONE_NUMBER}`} aria-label={`전화 연결 ${PHONE_NUMBER}`} className="block md:hidden">
        <img src={"/images/quickMo.png"} alt={`무료견적 365일 24시간 출장가능! ${PHONE_NUMBER}`} className="w-full" />
      </a>
    </div>
  );
}
